import { Text } from '@mantine/core';

/**
 * Transform decimal number to percentage text
 * @param {number} value - A decimal number (e.g. 0.25)
 * @returns {JSX.Element}
 */
const percentageTransform = (value) => {
  if (value) {
    return <Text>{ `${value}'%'`} </Text>;
  }
  return '';
};

export default percentageTransform;
